<template>
    <div class="cd-section" id="features" >
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/20161130_093946_1.jpg')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h1 class="title title-small">REFRIGERATION ENGINEERING + INTEGRITY</h1>
                        <h3>Great refrigeration engineers. A partner you can trust.</h3>
                    </div>
                </div>
            </div>
        </div>
        <!-- From engineering control systems to designing complete refrigeration systems. to make your system more efficient. From comissioning to complete system design. what can i do to my system to make it more efficient, better. From improving efficiency on your current system to complete design of a new system. VFDs on compressors, condensers, evap fans. We can  -->
        <!--     *********    PROJECTS 5     *********      -->
        <div class="projects-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">From Control Efficiency to Complete Refrigeration System Design</h2>
                        <!-- <h4 class="description">We engineer commercial and industrial refrigeration systems. Our engineers design modern control systems utilizing variable frequency drives, adaptive defrost controls, and other modern control innovations. We can make your existing system safer and more energy efficient. We’re problem solvers. Let us put our minds together to enhance your facility controls, and watch as everything becomes easier, smarter and more efficient. <a href="#" v-scroll-to="'#contact'" class="">Contact us</a></h4> -->
                        <h4 class="description">Leverage our 30+ years of experience designing cutting-edge refrigeration systems for your next refrigeration replacement project or in your new facility.  Our clients from around the globe have trusted the team at ETC to deliver turn-key custom refrigeration systems from design and engineering to installation and project management. Our refrigeration system design and installation experience ranges from national/independent food retailers store design to Fortune 100 pharmaceutical laboratories and warehouses. <a href="#contact" @click="gConversion()">Contact us</a></h4>
                        <!-- <h4 class="description">Energy efficiency and product safety drive our engineering process. Leveraging best in class technology, we deliver highly capable commercial and industrial refrigeration systems that offer rapid return on investment and lasting life cycles.</h4>
                        <h4 class="description">We’re problem solvers. Let us put our minds together to enhance your facility’s refrigeration system and watch as everything becomes easier, smarter and more efficient. <a href="#" v-scroll-to="'#contact'" class="">Contact us</a></h4> -->
                        <div class="section-space"></div>
                    </div>
                </div>
                <div class="row"  style="padding: 50px 0;">
                    <div class="col-md-5 ml-auto">
                        <card type="background" raised class="card-background-product" v-lazy:background-image="'img/20170823_080550.jpg'">
                            <h2 class="card-title">Refrigeration System Engineers</h2>
                            <p class="card-description">
                                Custom built refrigeration racks.
                            </p>
                        </card>
                    </div>
                    <div class="col-md-5 mr-auto">
                        <info-section type="danger"
                                      icon="now-ui-icons shopping_shop"
                                      title="Industrial &amp; Commercial"
                                      description="We engineer and design custom refrigeration equipment for industrial &amp; commercial applications including supermarkets, warehouses, and processing plants."
                        />
                        <info-section type="danger"
                                      icon="now-ui-icons design-2_ruler-pencil"
                                      title="Cold Room Design"
                                      description="Precision temperature &amp; humidity systems for pharmaceutical laboratories and testing facilities."
                        />

                        <info-section type="danger"
                                      icon="now-ui-icons objects_key-25"
                                      title="Turn-Key Solution"
                                      description="From racks, evaporators &amp; condensers to adaptive defrost &amp; superheat control. We design, engineer, supply &amp; install."
                        />
                    </div>
                </div>
                <!-- <hr/>
                <div class="row">
                    <div class="col-md-5 ml-auto last-p5card">
                        <info-section type="warning"
                                      icon="now-ui-icons loader_gear spin"
                                      title="Compressor Motor Speed Control"
                                      description="With Varaible Frequency Drives"
                        />

                        <info-section type="warning"
                                      icon="now-ui-icons loader_gear spin"
                                      title="Condenser/Evap Fan Speed Control"
                                      description="VFDs + Floating Head &amp; Fan Pulsing"
                        />
                        <info-section type="warning"
                                      icon="now-ui-icons ui-2_settings-90"
                                      title="Precise Superheat control"
                                      description="With Electronic Expansion Valves"
                        />
                        <info-section type="warning"
                                      icon="now-ui-icons arrows-1_refresh-69"
                                      title="Demand Defrost / Adaptive Defrost"
                                      description="Description here."
                        />
                    </div>
                    <div class="col-md-5 mr-auto">
                        <card type="background" raised class="card-background-product" v-lazy:background-image="'img/20180327_133947_1.jpg'">
                            <h2 class="card-title">Energy Audits / Refrigeration Efficiency</h2>
                            <p class="card-description ">
                                Description here.
                                PGO, Penn Term, Coop
                            </p>
                        </card>
                    </div>
                </div> -->
            </div>
        </div>
        <!--     *********    END PROJECTS 5      *********      -->
        <!--     *********    PROJECTS 4     *********      -->
        <div class="" data-background-color="gray">
            <div class="container-fluid">
                <!-- <div class="row">
                    <div class="col-md-8 mr-auto ml-auto text-center">
                        <h6 class="category text-muted">Our work</h6>
                        <h2 class="title">Some of Our Awesome Projects - 4</h2>
                    </div>
                </div> -->
                <div class="row">
                    <div class="col-md-6 px-0">
                        <card type="background" class="card-fashion"
                              style="background-image: url('img/20170913_094627.jpg')">
                            <div class="card-body">
                                <div class="card-title text-left">
                                    <h3>
                                        Full Facility EMS - Energy Management System Installation: Refrigeration, HVAC, Lighting, Exhaust Fans, Energy Monitoring 
                                    </h3>
                                </div>
                                <!-- <div class="card-footer text-left">
                                    <div class="stats">
                                            <span>
                                                <i class="now-ui-icons objects_globe"></i>The “Crazy idea” project
                                            </span>
                                    </div>
                                </div> -->
                            </div>
                        </card>
                    </div>
                    <div class="col-md-6 px-0">
                        <!-- <div class="card-container"> -->
                            <!-- <div class="card card-fashion" style="background-color: #183858b3; color:white;">
                                <div class="card-title">
                                        <h4>
                                            Design the Modernization of Control systems – Retro-fits 
                                        </h4>
                                </div>
                            </div> -->
                            <!-- <card type="background" class="card-fashion"
                                  style="background-image: url('img/20170508_104732.jpg')"> -->
                            <card type="background" class="card-fashion"
                                  style="background-image: url('img/modernize.jpg')">
                                  <div class="card-title text-right">
                                        <h3>
                                            Modernization Design of Legacy Control Systems – Retro-fits 
                                        </h3>
                                </div>
                            </card>
                        <!-- </div> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 px-0">
                        <!-- <div class="card-container"> -->
                            <!-- <card type="background" class="card-fashion"
                                  style="background-image: url('img/20180116_123857.jpg')"> -->
                            <card type="background" class="card-fashion"
                                  style="background-image: url('img/industrial.png')">
                                  <div class="card-title text-left">
                                    <h3>
                                        Custom Panel Fabrication 
                                    </h3>
                                </div>
                            </card>
                            <!-- <div class="card card-fashion arrow-left" style="background-color: #183858b3; color:white;">
                                <div class="card-title">
                                    <h4>
                                        Panel Fabrication 
                                    </h4>
                                </div>
                                
                            </div> -->
                        <!-- </div> -->
                    </div>
                    <div class="col-md-6 px-0">
                        <card type="background" class="card-fashion"
                              style="background-image: url('img/diagram.png')">
                            <div class="card-title text-right">
                                <h3>Engineering Drawings </h3>
                            </div>
                            <!-- <div class="card-footer text-left">
                                <div class="stats">
                                    <span>
                                        <i class="now-ui-icons media-2_sound-wave"></i>The "Premortem" project
                                    </span>
                                </div>
                            </div> -->
                        </card>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END PROJECTS 4      *********      -->
        <!--     *********    PROJECTS 5     *********      -->
        <div class="projects-5">
            <div class="container" style="padding-top: 50px;padding-bottom: 50px;">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Refrigeration Efficiency</h2>
                        <!-- <h4 class="description">We engineer commercial and industrial refrigeration systems. Our engineers design modern control systems utilizing variable frequency drives, adaptive defrost controls, and other modern control innovations. We can make your existing system safer and more energy efficient. We’re problem solvers. Let us put our minds together to enhance your facility controls, and watch as everything becomes easier, smarter and more efficient. <a href="#" v-scroll-to="'#contact'" class="">Contact us</a></h4> -->
                        <!-- <h4 class="description">Leverage our 30+ years of experience designing cutting-edge refrigeration systems for your next refrigeration replacement project or in your new facility.  Our clients from around the globe have trusted the team at ETC to deliver turn-key custom refrigeration systems from design and engineering to installation and project management. Our refrigeration system design and installation experience ranges from national/independent food retailers store design to Fortune 100 pharmaceutical laboratories and warehouses. <a href="#" v-scroll-to="'#contact'" class="">Contact us</a></h4> -->
                        <h4 class="description">Energy efficiency and product safety drive our engineering process. Leveraging best in class technology, our refrigeration engineers deliver highly capable commercial &amp; industrial refrigeration systems that offer rapid return on investment and lasting reliability. <a href="#contact" @click="gConversion()">Contact&nbsp;us</a></h4>
                        <div class="section-space"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 ml-auto last-p5card">
                        <info-section type="warning"
                                      icon="now-ui-icons loader_gear spin"
                                      title="Compressor Motor Speed Control"
                                      description="With Varaible Frequency Drives"
                        />

                        <info-section type="warning"
                                      icon="now-ui-icons loader_gear spin"
                                      title="Condenser/Evap Fan Speed Control"
                                      description="VFDs + Floating Head &amp; Fan Pulsing"
                        />
                        <info-section type="warning"
                                      icon="now-ui-icons ui-2_settings-90"
                                      title="Precise Superheat control"
                                      description="With Electronic Expansion Valves"
                        />
                        <info-section type="warning"
                                      icon="now-ui-icons arrows-1_refresh-69"
                                      title="Defrost on Demand"
                                      description="Defrost only when needed"
                        />
                    </div>
                    <div class="col-md-5 mr-auto">
                        <card type="background" raised class="card-background-product" v-lazy:background-image="'img/20180327_133947_1.jpg'">
                            <h2 class="card-title">Energy Audits / Refrigeration Efficiency</h2>
                            <p class="card-description ">
                                Your existing system <i class="fas fa-arrow-right"></i> Better
                            </p>
                        </card>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END PROJECTS 5      *********      -->
        <!--     *********     FEATURES 7      *********      -->
        <div class="features-7 section-image" style="background-image: url('img/20170802_131651.jpg')">
            <div class="col-md-8 mr-auto ml-auto text-center">
                <h2 class="title">Refrigeration System Safety </h2>
                <h4 class="description">Designing your system to meet safety standards and to protect against failure.</h4>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6 px-0">
                        <div class="col-sm-12">
                            <div class="info info-horizontal">
                                <div class="icon">
                                    <i class="fas fa-list-ul"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Food Safety – HACCP/PSM </h4>
                                    <p class="description">Hazard Analysis and Critical Control Points reporting &amp; Process Safety Management. </p>
                                </div>
                            </div>
                            <div class="info info-horizontal">
                                <div class="icon">
                                    <i class="fas fa-wrench"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Compressor Safety</h4>
                                    <p class="description">High/Low Pressure cutouts to prevent compressor failure. Remote resets. </p>
                                </div>
                            </div>
                            <div class="info info-horizontal">
                                <div class="icon">
                                    <i class="fas fa-cog"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Condenser Safey </h4>
                                    <p class="description">Amperage monitoring, fan proofs, pressure overides. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="col-sm-12">
                            <div class="info info-horizontal sm-no-top">
                                <div class="icon">
                                    <i class="fas fa-deaf"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Noise Cancelation </h4>
                                    <p class="description">Fan speed control to reduce noise in order to comply with OSHA and CDC standards. </p>
                                </div>
                            </div>
                            <div class="info info-horizontal">
                                <div class="icon">
                                    <i class="fab fa-cloudscale"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Leak Detection </h4>
                                    <p class="description">Monitoring refrigerant leaks. </p>
                                </div>
                                
                            </div>
                            <div class="info info-horizontal">
                                <div class="icon">
                                    <i class="far fa-snowflake"></i>
                                </div>
                                <div class="description">
                                    <h4 class="info-title">Freezer Floor Safety </h4>
                                    <p class="description">Monitor &amp; control freezer floor temperatures before they crack.</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="image-container">
                            <img v-lazy="'img/ipadgamshaccp.png'" alt="">
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 7      *********      -->

        <!--     *********     BLOGS 3      *********      -->
        <div class="blogs-3" v-if="latest != null && latest.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h2 class="title">Related Articles</h2>
                        <br />
                        <template  v-for="article in latest">
                        <card type="blog" plain :key="article._id">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" v-lazy="article.headerimg" @click="goTo(article._id)"  style="cursor:pointer;"/>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title">
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">{{article.title}}</router-link>
                                    </h3>
                                    <p class="card-description">
                                        {{article.readmore}}
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">Read More</router-link>
                                    </p>
                                    <div class="author">
                                        <img v-lazy="article.authorimg" alt="..." class="avatar img-raised">
                                        <span>{{article.author}}</span>
                                    </div>
                                </div>
                            </div>
                        </card>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END BLOGS 3      *********      -->
        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>
<script>
  import Contact from './components/Contact'
  import { Card, InfoSection } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'engineering-page',
    components: {
      Contact,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Commercial & Industrial Refrigeration Engineering',
      meta: [
        { vmid: 'description', name: 'description', content: 'We specialize in modern refrigeration systems, from control efficiency to complete refrigeration system design. Racks, evaporators, condensers, adaptive defrost, superheat control, VFDs, humidity control' },
        { vmid: 'keywords', name: 'keywords', content: 'refrigeration engineering, commercial refrigeration, industrial refrigeration, danfoss, emerson, cpc, HVAC, controls, refrigeration controls, food safety, humidity control, refrigeration compressor, refrigeration condenser, condenser fans, variable frequency drives, vfd, defrost control, leak detection, noise cancelation, refrigeration efficiency ' }
      ],
      links: [
                {rel: 'canonical', href: 'https://electronictechcorp.com/facility-refrigeration-engineering'}
            ]
    },
    data () {
        return {
            latest: null,
            domain: 'https://api.website.gamsplus.systems',
        }
    },
    mounted() {
        this.getLatest()

        // window.dataLayer = window.dataLayer || [];
        // function gtag() {
        //     dataLayer.push(arguments);
        // }
        // gtag('js', new Date());
        // gtag('config', 'UA-89795959-13');

    },
    methods: {
        // track () {
        //     // setTimeout(() => {
        //         this.$ga.page(this.$router)
        //     // }, 1000);
        // },
        getLatest() {
            this.$http.post(this.domain+'/articles/similar/Engineering',{
                    'title': '',
                },{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                this.latest = data.body
               
            })
        },
        goTo(articleID) {
            this.$router.push({ path: '/article', query: { id: articleID }})
            // window.scrollTo(0,0);
        },
        gConversion(){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
        }
    },
  }


</script>
<style scoped>
@media screen and (min-width: 991px){
    h1.title{
        font-size:7em;
    }
    h1.title-small{
        font-size:5.5em !important;
    }
}
@media screen and (max-width: 990px){
    h1.title-small{
        font-size:5em !important;
    }
}
@media (max-width: 768px){
    h1.title{
        font-size:5em;
    }
    h1.title-small{
        font-size:4em !important;
    }
    .section-story-overview .image-container:nth-child(2) {
        margin-top: 420px;
        margin-left: auto;
        margin-bottom: 30px;
    }
    .section-story-overview .image-container.image-right {
        margin-bottom: 50px;
    }
    .image-container.image-left p.blockquote {
        margin: 50px auto;
        position: relative;
        right: 0;
        top: 400px;
    }
    .image-container.image-left {
        margin-bottom: auto;
    }
    .projects-5 .card-background {
        margin-bottom: 30px;
    }
    .projects-5 hr {
        margin-bottom: 3rem;
    }
    .last-p5card{
        margin-bottom: 50px;
    }
    .info.info-horizontal.sm-no-top {
        padding-top: 15px;
    }
}

@media screen and (max-width: 576px){
    h1.title{
        font-size:3.5em;
    }
    h1.title-small{
        font-size:3em !important;
    }
}
@media screen and (max-width: 410px){
    h1.title-small{
        font-size:2.5em !important;
    }
}
@media screen and (max-width: 330px){
    h1.title-small{
        font-size:2em !important;
    }
}
.section-story-overview p.blockquote {
    width: 280px;
}
.features-7:after, .features-2:after, .features-8:after {
    background-color: rgba(0, 0, 0, 0.7);
}
.info .icon > i {
    width: 25px;
}
.info{
    max-width: 360px !important;
}
.engineering-page .card-container {
    width: auto;
    margin-top: 0px;
}
.card-fashion.arrow-left:not(.card-background):before {
    border-right-color: #536b84;
}
.card-fashion:not(.card-background):before {
    border-left-color: #536b84;
}
</style>